module.exports = __webpack_public_path__ + "img/title_no.668252c3.svg";